import React, { useEffect, useState } from "react";
import { Form, Input, Popover, Select } from "antd";
import style from "../props.module.sass";
import { ReactComponent as PlusIcon } from "../../../../../../../assets/svg/plus_btn.svg";

const { Option } = Select;

interface IProps {
  json: any;
  options: any;
  updateOptions: (data: any, key: string) => void;
  canEdit?: boolean;
}

const validationTypeList = [
  {
    label: "Min",
    value: "min",
    validType: "Number",
  },
  {
    label: "Max",
    value: "max",
    validType: "Number",
  },
  {
    label: "Min Length",
    value: "minlength",
    validType: "Input",
  },
  {
    label: "Max Length",
    value: "maxlength",
    validType: "Input",
  },
  {
    label: "Pattern",
    value: "pattern",
    validType: "All",
  },
];

const valueFormatList = [
  {
    label: "Auto",
    value: "auto",
  },
  {
    label: "Integer",
    value: "integer",
  },
  {
    label: "Long",
    value: "long",
  },
  {
    label: "Double",
    value: "double",
  },
  {
    label: "String",
    value: "string",
  },
]

const AddLabelValue = (props: IProps) => {
  const { canEdit = true } = props;
  const [label, setLabel] = useState("");
  const [value, setValue] = useState("");
  const [patternErrorMessage, setPatternErrorMessage] = useState(
    "Invalid Value"
  );
  const [labelOptionsList, setLabelOptionsList] = useState(
    validationTypeList || []
  );
  const [valueFormat, setValueFormat] = useState("auto")
  const valueText: string =
    props.json.type === "Table"
      ? props.json.data.mode === "form"
        ? "Bind Variable"
        : "Data"
      : "Value";

  const [labelErr, setLabelErr] = useState(false);
  const [valueErr, setValueErr] = useState(false);
  const [ErrMessage, setErrMessage] = useState("");

  const [valueErrPopup, setValueErrPopup] = useState(false);

  const options: any = props.options || {};

  const checkIfPresent = (range: any, key: any) => {
    return !!range[key];
  };

  const checkValue = (key: string, prop: string): boolean => {
    switch (key) {
      case "min":
        const { max } = options;
        if (!!max) {
          return Number(options["max"]) >= Number(prop);
        }
        return true;
      case "max":
        const { min } = options;
        if (!!min) {
          return Number(options["min"]) <= Number(prop);
        }
        return true;
      case "minlength":
        const { maxlength } = options;
        if (!!maxlength) {
          return Number(options["maxlength"]) >= Number(prop);
        }
        return true;
      case "maxlength":
        const { minlength } = options;
        if (!!minlength) {
          return Number(options["minlength"]) <= Number(prop);
        }
        return true;
      case "pattern":
        return true;
      default:
        return true;
    }
  };

  const getErrorMessage = (errLabel: string): string => {
    switch (errLabel) {
      case "min":
        return "Min value should be lesser than max value";
      case "max":
        return "Max value should be greater than min value";
      case "minlength":
        return "Min-length should be less than max-length";
      case "maxlength":
        return "Max-length should be greater than min-length";
      default:
        return "Error";
    }
  };

  const addOption = () => {
    const labelPresent = checkIfPresent(options, label);
    setLabelErr(!label || labelPresent ? true : false);
    if (!label && !value) {
      setValueErr(true);
      setLabelErr(true);
    } else if (!label) {
      setLabelErr(true);
    } else if (!value) {
      setValueErr(true);
    } else if (labelPresent && Object.keys(options).length > 0) {
      setLabelErr(true);
    } else {
      if (checkValue(label, value)) {
        let payload: any;
        if (label === "pattern") {
          payload = {
            ...props.json.properties,
            [label]: value,
            errorMessage: patternErrorMessage,
          };
        } else {
          payload = {
            ...props.json.properties,
            [label]: value,
          };
        }
        const validOptions = ["min", "max", "minlength", "maxlength", "pattern", "errorMessage"]
        const finalOptions: any = {}
        validOptions.forEach((item) => {
          if (payload[item]) {
            finalOptions[item] = payload[item]
          }
        })
        // sending empty field to redux to let it know that we are intentionally sending no validations
        if (Object.entries(finalOptions).length === 0) {
          finalOptions['empty'] = true
        }
        setLabel("");
        setValue("");
        props.updateOptions(finalOptions, `properties`);
      } else {
        setValueErr(true);
        setErrMessage(getErrorMessage(label));
      }
    }
    // setTimeout(() => {
    //   setValueErr(false);
    //   setLabelErr(false);
    //   setErrMessage("");
    // }, 5000);
  };

  const popOverVisibleChange = (item: string, visible: boolean) => {
    //On mouse out
    if (!visible) {
      setValueErrPopup(false);
    } else {
      if (item === "value") {
        valueErr ? setValueErrPopup(true) : setValueErrPopup(false);
      }
    }
  };

  useEffect(() => {
    const { properties } = props.json;
    let filteredList = [];
    if (properties && properties.category === "number") {
      setValueFormat(props?.json?.properties?.valueFormat || "auto")
      filteredList = validationTypeList.filter(
        (item) => item.validType === "Number" || item.validType === "All"
      );
    } else {
      filteredList = validationTypeList.filter(
        (item) => item.validType !== "Number"
      );
    }
    const updatedList = filteredList.filter(
      (item) => !(properties && properties[item.value])
    );
    setLabelOptionsList(updatedList);
  }, [props.json]);

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          flexDirection: "column"
        }}
      >
        <Form.Item
          label="Validation Type"
          className={"a8-form-item props"}
          style={{ marginBottom: 0 }}
        >
          <Select
            data-test-id="validation_select"
            disabled={!canEdit}
            style={{ width: '100%' }}
            defaultValue={label}
            value={label}
            onChange={(e: any) => {
              setLabel(e);
              setLabelErr(false);
            }}
            className={`${labelErr ? style.inputError : style.input} ${style.borderRemove
              }`}
          >
            {labelOptionsList.map((listType, index) => (
              <Option data-test-id={`validation_option${listType.value}`} key={index} value={listType.value}>{listType.label}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label={valueText} className={"a8-form-item props"}>
          <Popover
            visible={valueErrPopup}
            onVisibleChange={(visible) =>
              popOverVisibleChange("value", visible)
            }
            placement="topLeft"
            trigger="hover"
            content={
              <div style={{ color: "#ff7e7a", padding: "0" }}>
                {value
                  ? `${valueText} exists`
                  : `Empty ${valueText.toLowerCase()}`}
              </div>
            }
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
              <Input
                style={{ flexGrow: 1, marginRight: 10 }}
                disabled={!canEdit}
                placeholder={`Enter ${valueText}`}
                value={value}
                type={label === "pattern" ? "text" : "number"}
                onChange={(e) => {
                  setValue(e.target.value);
                  setValueErr(false);
                  setValueErrPopup(false);
                  setErrMessage("");
                }}
                data-test-id="validation_input_value" className={`${valueErr ? style.inputError : style.input} ${style.borderRemove
                  }`}
              />
              <div className={style.iconContainer} style={{ top: 0 }}>
                <PlusIcon
                  data-test-id="validation_plus_icon"
                  width="30px"
                  height="30px"
                  style={{ cursor: "pointer" }}
                  onClick={() => canEdit && addOption()}
                />
              </div>
            </div>
          </Popover>
        </Form.Item>
      </div>
      <div>
        {label === "pattern" && (
          <Form.Item label="Error Message" className="a8-form-item props">
            <Input
              data-test-id="validation_input_error_message"
              disabled={!canEdit}
              placeholder="Enter error message"
              required={true}
              value={patternErrorMessage}
              onChange={(e) => {
                setPatternErrorMessage(e.target.value);
                setErrMessage("");
              }}
            />
          </Form.Item>
        )}
      </div>
      {ErrMessage && (
        <p data-test-id="validation_error_message" style={{ color: "red", textAlign: "left", marginTop: "10px" }}>{ErrMessage}</p>
      )}
      {props?.json?.properties?.category === "number" && <Form.Item
        label="Value Format"
        className={"a8-form-item props"}
        style={{ marginBottom: 0 }}
      >
        <Select
          data-test-id="value_format"
          disabled={!canEdit}
          style={{ width: '100%' }}
          defaultValue={valueFormat}
          value={valueFormat}
          onChange={(e: any) => {
            setValueFormat(e)
            props.updateOptions({ valueFormat: e }, `properties`);
          }}
          className={`${style.input} ${style.borderRemove
            }`}
        >
          {valueFormatList.map((valueFormatType, index) => (
            <Option data-test-id={`valueFormat_option${valueFormatType.value}`} key={index} value={valueFormatType.value}>{valueFormatType.label}</Option>
          ))}
        </Select>
      </Form.Item>}
    </React.Fragment>
  );
};

export default AddLabelValue;
